import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType } from 'api/utils/RepositoryTypes';
import { SimpleProductType } from './SimpleProduct';

type Props = {
    code: string;
};

export interface ProductsSetType {
    code: string;
    sections: Array<{
        sectionName: string;
        minimumTitleQuantity: number;
        maximumTitleQuantity: number;
        minimumSectionQuantity: number;
        products: Array<SimpleProductType>;
        sectionProductPrice: number;
    }>;
}

class SimpleProductRepository extends BaseRepositoryClass implements RepositoryType {
    get({ code }: Props) {
        return this.requester.get<ProductsSetType>(`grant/promotional-set/by-code/${code}`);
    }
}

export default SimpleProductRepository;
